import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ClientAction } from '../client.action';

type IDependencies = IClientApiDependencySegment;

export const removeClientEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ClientAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteClient(params).pipe(
      mergeMap(() => {
        return [
          ClientAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          ClientAction.remove.failed({ params, error: null }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
